import {
    FETCH_DIAGNOSES_REQUEST, FETCH_DIAGNOSES_SUCCESS, FETCH_DIAGNOSES_FAILURE,
    CREATE_DIAGNOSIS_SUCCESS, UPDATE_DIAGNOSIS_SUCCESS, DELETE_DIAGNOSIS_SUCCESS
  } from '../actions/diagnosisActions';
  
  const initialState = {
    diagnoses: [],
    loading: false,
    error: null,
  };
  
  export default function diagnosisReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_DIAGNOSES_REQUEST:
        return { ...state, loading: true };
      case FETCH_DIAGNOSES_SUCCESS:
        return { ...state, loading: false, diagnoses: action.payload };
      case FETCH_DIAGNOSES_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_DIAGNOSIS_SUCCESS:
        return { ...state, diagnoses: [...state.diagnoses, action.payload] };
      case UPDATE_DIAGNOSIS_SUCCESS:
        return {
          ...state,
          diagnoses: state.diagnoses.map((diagnosis) =>
            diagnosis.id === action.payload.id ? action.payload : diagnosis
          ),
        };
      case DELETE_DIAGNOSIS_SUCCESS:
        return {
          ...state,
          diagnoses: state.diagnoses.filter((diagnosis) => diagnosis.id !== action.payload),
        };
      default:
        return state;
    }
  }
  